const scriptLoadPromises: Record<string, Promise<void> | undefined> = {};

type LoadScriptOnceOptions = {
  isReady?: () => boolean;
};

export function loadScriptOnce(src: string, options: LoadScriptOnceOptions = {}): Promise<void> {
  if (scriptLoadPromises[src]) {
    return scriptLoadPromises[src];
  }

  scriptLoadPromises[src] = new Promise<void>((resolve, reject) => {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const existingScript = scripts.find((scriptEl) => {
      const scriptSrc = scriptEl.getAttribute('src') || '';
      return scriptSrc === src || scriptEl.src === src;
    });

    const onLoad = () => resolve();
    const onError = () => {
      delete scriptLoadPromises[src];
      reject(new Error(`Could not load script: ${src}`));
    };

    if (existingScript) {
      if (options.isReady?.()) {
        resolve();
        return;
      }

      existingScript.addEventListener('load', onLoad, { once: true });
      existingScript.addEventListener('error', onError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    document.head.appendChild(script);
  });

  return scriptLoadPromises[src];
}
